import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { PaletteMode } from '@mui/material'

export interface CurrentModeState {
  mode: PaletteMode
}

const initialState: CurrentModeState = {
  mode: 'light',
}

export const currentModeSlice = createSlice({
  name: 'darkMode',
  initialState,
  reducers: {
    toggleMode: state => {
      state.mode = state.mode === 'light' ? 'dark' : 'light'
      localStorage.setItem('darkMode', state.mode)
    },
    setMode: (state, action: PayloadAction<PaletteMode>) => {
      state.mode = action.payload
    },
  },
})

export const getCurrentMode = (state: RootState) => state.darkMode.mode

export const { toggleMode, setMode } = currentModeSlice.actions
export const currentModeReducer = currentModeSlice.reducer

export default currentModeReducer
